export * from './resizable.module';
export { ResizableDirective as Resizable } from './resizable.directive';
export { ResizeHandleDirective as ResizeHandle } from './resize-handle.directive';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/angular-resizable-element/dist/esm/src/index.js
// module id = ../../../../angular-resizable-element/dist/esm/src/index.js
// module chunks = vendor